export const CONSOLE_LINK = "https://console.dekube.net/";
export const MONITORING_LINK = "https://monitoring.dekube.net/";
